<template>
  <div class="card">
    <slot/>
  </div>
</template>
<script>
    export default {
        components: {

        },

        data () {
            return {

            }
        },

        computed: {},

        watch: {},

        methods: {

        },

        mounted () {

        },

        created () {}

    }
</script>
<style scoped lang="less">
.card{
    background:rgba(255,255,255,1);
    box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
    border-radius:3px;
  }
</style>
